import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./Components/Header";
import { store } from "./store";
import Footer from "./Components/Footer";
import Casinopage from "./screens/CasinoPage/Casinopage";
import Transactionpage from "./screens/TransactionPage/Transactionpage";
import CenterLeague from "./screens/HomePage/centerPart/CenterLeague";
import MtachProfile from "./screens/HomePage/matchProfile/MtachProfile";
import { PublicRoute } from "./middlewares/AuthMiddleware";
import { Provider } from "react-redux";
import NotFoundPage from "./screens/404/NotFoundPage";
import { Suspense } from "react";
import BetPage from "./screens/BetPage/BetPage";
import ProtectedRoute from "./Components/ProtectedRoute";
import { ToastProvider } from "./screens/notificationPage/ToastContainer";
import Accountpage from "./screens/AccountPage/AccountPage";
import GamePage from "./screens/CasinoPage/GameIFrame";
import FundsPage from "./screens/Funds/FundsPage";
import TawkMessengerWidget from "./Components/TaskMessageWidget";
import TermsAndConditionsPage from "./screens/Terms/TermsAndContionsPage";
import NotificationPage from "./screens/Notification/Notification";
import NtfPage from "./screens/Notification/NotificationPage";
import JackpotDashboard from "./Components/PragamticJackpots";
import CasinoBetHistoryPage from "./screens/BetPage/CasinoBetHistoryPage";
function App() {
  return (
    <Provider store={store}>
      <TawkMessengerWidget />
      <Router>
        <ToastProvider>
          <Routes>
            <Route path="/header" element={<Header />} />
            <Route path="/footer" element={<Footer />} />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Accountpage />
                </ProtectedRoute>
              }
            />
            {/* Redirect from "/" to "/casino" */}
            <Route path="/" element={<Navigate to="/casino" replace />} />

            {/* Optionally redirect from "/home" to "/casino" too */}
            <Route path="/home" element={<Navigate to="/casino" replace />} />
            {/* <Route
              path="/"
              element={
                <PublicRoute>
                  <Casinopage />
                </PublicRoute>
              }
            /> */}
            {/* <Route
              path="/home"
              element={
                <PublicRoute>
                  <Casinopage />
                </PublicRoute>
              }
            /> */}
            <Route
              path="/ntf"
              element={
                <ProtectedRoute>
                  <NtfPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/terms"
              element={
                <PublicRoute>
                  <TermsAndConditionsPage />
                </PublicRoute>
              }
            />
            <Route
              path="/sports"
              element={
                <PublicRoute>
                  <CenterLeague />
                </PublicRoute>
              }
            />
            <Route path="/match/:id" element={<MtachProfile />} />
            {/* <Route path="/matchprofile" element={<MtachProfile />} /> */}
            <Route
              path="/casino"
              element={
                <PublicRoute>
                  <Casinopage />
                </PublicRoute>
              }
            />
            <Route
              path="/pragmaticjackpot"
              element={
                <PublicRoute>
                  <JackpotDashboard />
                </PublicRoute>
              }
            />
            <Route
              path="/bet-history"
              element={
                <ProtectedRoute>
                  <BetPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/casino-history"
              element={
                <ProtectedRoute>
                  <CasinoBetHistoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/funds/:id"
              element={
                <ProtectedRoute>
                  <FundsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/funds"
              element={
                <ProtectedRoute>
                  <FundsPage />
                </ProtectedRoute>
              }
            />
            <Route path="/game/:gameAlias" element={<GamePage />} />
            <Route
              path="/transaction"
              element={
                <ProtectedRoute>
                  <Transactionpage />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <NotFoundPage />
                </Suspense>
              }
            />
            {/* 404 page - This will catch all undefined routes */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ToastProvider>
      </Router>
    </Provider>
  );
}

export default App;
